type PermissionObject = {
  [key: string]: boolean
}

export const onePermission = (permissions: PermissionObject) => {
  return Object.values(permissions).some((permission) => permission === true)
}
